import { render, staticRenderFns } from "./NhstResetPassword.vue?vue&type=template&id=2b429c1d"
import script from "./NhstResetPassword.vue?vue&type=script&lang=js"
export * from "./NhstResetPassword.vue?vue&type=script&lang=js"
import style0 from "./NhstResetPassword.vue?vue&type=style&index=0&id=2b429c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports